@if (state.isActive()) {
  <div class="session-bar">
    <div class="session-bar__status">
      <span class="session-bar__dot"></span>
      <span>{{ 'Signing_Bar_Active' | translateWF: 'Active Session:' }}</span>
      <span class="session-bar__clock">{{ clock() }}</span>
      <span class="session-bar__expiry" pTooltip="{{ 'Signing_Bar_Expiry_Tooltip' | translateWF: 'The session closes after this time without signing activity' }}">
        · {{ 'Signing_Bar_ExpiresIn' | translateWF: 'expires in' }} {{ expiry() }}
      </span>
    </div>
    <a href="#" class="session-bar__end" (click)="requestEnd($event)">{{ 'Signing_Bar_End' | translateWF: 'End Session' }}</a>
  </div>
}

<p-dialog
  [(visible)]="confirmOpen"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '380px' }"
  header="{{ 'Signing_End_Title' | translateWF: 'End Signing Session?' }}"
>
  <p class="session-bar__dialog-text">
    {{ 'Signing_End_Body' | translateWF: "This closes your active session. Any documents you haven't signed yet will stay pending until you start a new session." }}
  </p>
  <ng-template #footer>
    <p-button variant="text" label="{{ 'Cancel' | translateWF: 'Cancel' }}" (onClick)="confirmOpen.set(false)" />
    <p-button severity="danger" label="{{ 'Signing_Bar_End' | translateWF: 'End Session' }}" [loading]="ending()" (onClick)="confirmEnd()" />
  </ng-template>
</p-dialog>
